<template>
  <div>
    <b-link @click="onClick">
      <small class="text-primary">{{ label }}</small>
    </b-link>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'LinkText',
  components: {
    BLink,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    onClick: {
      type: Function,
      default: () => {},
      required: false,
    },
  },
}
</script>
<style scoped>
.text-primary {
    color: var(--primary) !important;
  }
</style>
